module.exports = __webpack_public_path__ + "img/pause-circle-icon.9876d06d.svg";